<template>
  <div ref="container" style="height: 100%; width: 100%;"></div>
</template>

<script>
import JSONEditor from 'jsoneditor'
import 'jsoneditor/dist/jsoneditor.css'

export default {
  name: 'JsonEditor',
  props: {
    value: { // equivalente ao modelValue no Vue 3
      type: [Object, Array],
      required: true
    },
    mode: {
      type: String,
      default: 'code'
    },
    mainMenuBar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editor: null
    }
  },
  mounted() {
    this.editor = new JSONEditor(this.$refs.container, {
      mode: this.mode,
      mainMenuBar: this.mainMenuBar,
      onChange: () => {
        try {
          const newValue = this.editor.get()
          this.$emit('input', newValue) // padrão do v-model no Vue 2
        } catch (err) {
          // Ignora erros de parse enquanto edita
        }
      }
    })
    this.editor.set(this.value)
  },
  watch: {
    value(newVal) {
      try {
        const current = this.editor.get()
        if (JSON.stringify(current) !== JSON.stringify(newVal)) {
          this.editor.update(newVal)
        }
      } catch (_) {
        this.editor.set(newVal)
      }
    }
  },
  beforeDestroy() {
    this.editor && this.editor.destroy()
  }
}
</script>

<style>
@import "~jsoneditor/dist/jsoneditor.css";
</style>
